import React from 'react'

const RecurringAccount = () => {
    const conditons = [
        'Minimum amount is Rs. 1000/- per month and thereafter multiples of Rs. 1000/-',
        'Interest rate will be calculated on yearly basis',
        'Lapse on payment of installment amount will make the defaulter pay Rs. 2 per 100 (Rs. 20 per 1000) along with installment amount',
        'Maturity amount will be paid one month after the last installment or maturity due date, whichever is later',
        'On irregular deposits, if all pending deposits are paid, the account will be treated as regular',
        'Even a single missed installment will mark the account as irregular',
        'After maturity, payment on irregular accounts will be made after deducting penalty up to the limit of interest earned. Principal will not be deducted',
        'Loan facility available based on Recurring Deposit',
        'Revised interest on irregular account will be calculated from the last payment date as per company rules',
        'No premature closure or foreclosure facility available',
        'Nomination is compulsory. If nominee is a minor, an appointee with KYC is required',
        'Recurring Deposit can be opened only by individuals. Joint account facility is not available',
        'Minor cannot open a Recurring Deposit',
        'All interest payments are subject to TDS deduction as per Government rules',
        'Maturity will be paid via Account Payee Cheque only'
    ];
    return (
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 flex flex-col gap-8'>
            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Recurring Deposite
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    A recurring deposit means making regular deposits. It is a service provided by Credito India Nidhi Limited, where people can make regular deposits and earn decent returns on their investments. Recurring Deposit schemes allow customers an opportunity to build up their savings through regular monthly deposits of a fixed sum over a fixed period of time. The minimum period of a recurring deposit is six months and the maximum is five years. CREDITO India Nidhi Limited introduces Flexi Recurring Deposit Schemes.
                </p>
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Feature of Recurring Deposite
                </h2>

                <div className='border'>
                    <div className='flex flex-row'>
                        <div style={{ flex: 1 }} className='bg-blue-600 border flex items-center justify-center'>
                            <p className='font-bold text-white text-md text-center'>Tenure</p>
                        </div>
                        <div style={{ flex: 2 }} className='bg-blue-600 border'>
                            <div className='p-4'>
                                <p className='font-bold text-white text-md text-center'>Denomination</p>
                            </div>
                            <div className='flex'>
                                <div className='flex-1 border p-4'>
                                    <p className='font-bold text-white text-md text-center'>General</p>
                                </div>
                                <div className='flex-1 border p-4'>
                                    <p className='font-bold text-white text-md text-center '>Sr. Citizen</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='flex '>
                        <div className='flex-1 p-4 '>
                            <p className='font-medium  text-md text-center'>36 Month</p>
                        </div>
                        <div className='flex-1 p-4 '>
                            <p className='font-medium text-md text-center'>8%</p>
                        </div>
                        <div className='flex-1 p-4'>
                            <p className='font-medium text-md text-center'>8.50%</p>
                        </div>
                    </div>
                    <div className='flex '>
                        <div className='flex-1 p-4 '>
                            <p className='font-medium  text-md text-center'>60 Month</p>
                        </div>
                        <div className='flex-1 p-4 '>
                            <p className='font-medium text-md text-center'>9%</p>
                        </div>
                        <div className='flex-1 p-4'>
                            <p className='font-medium text-md text-center'>9.50%</p>
                        </div>
                    </div>
                    <div className='flex '>
                        <div className='flex-1 p-4 '>
                            <p className='font-medium  text-md text-center'>84 Month</p>
                        </div>
                        <div className='flex-1 p-4 '>
                            <p className='font-medium text-md text-center'>10%</p>
                        </div>
                        <div className='flex-1 p-4'>
                            <p className='font-medium text-md text-center'>10.50%</p>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Condition
                </h2>
                {conditons.map((point, featureIndex) => (
                    <div key={featureIndex} className="flex items-center space-x-2">
                        <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
                        <span className="text-md text-gray-600">{point}</span>
                    </div>
                ))}
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Issue of Passbook
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    A passbook will be issued to every Member Account Holder. The Member Account Holder shall get the passbook updated at regular intervals. If any discrepancy or difference in the amount is found between the entries made in the passbook and receipts duly countersigned by the authorized signatory of the branch office bearing seal. Payments shall be made on the basis of receipts only.
                </p>
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Loan Facility on Recurring Deposits
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    A passbook will be issued to every Member Account Holder. The Member Account Holder shall get the passbook updated at regular intervals. If any discrepancy or difference in the amount is found between the entries made in the passbook and receipts duly countersigned by the authorized signatory of the branch office bearing seal. Payments shall be made on the basis of receipts only.
                </p>
            </div>

            <div>
                <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    Pre Mature Closure of Deposit
                </h2>
                <p className="text-md text-gray-600 mx-auto leading-relaxed">
                    Fore closure of deposits will not be permitted until completion of 6 months from the date of deposits, Deposits foreclosed after 6 months but before 12 months from the date of deposits no interest will be paid. Deposits foreclosed after 6 months, interest 2% shall be deducted from the normal rate of simple interest for the period of deposit.
                </p>
            </div>
        </div>
    )
}

export default RecurringAccount
